// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2QbnM","question":"Question_question__37SR8","description":"Question_description__OLRD4"};